import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable, of } from 'rxjs';
import { environment } from '@environments/environment';

@Injectable({
  providedIn: 'root'
})
export class PayrixService {

  constructor(private _httpClient: HttpClient) { }

  post(model: any): Observable<any> {
    return this._httpClient.post(`${environment.API_URL}/api/seller/payment`,model);
  }

  stripePayment(data: any): Observable<any> {
    return this._httpClient.post(`${environment.API_URL}/api/seller/stripePayment`,data);
  }

  saveTxn(data: any): Observable<any> {
    if(data) {
      var now = new Date(); var utc = new Date(now. getTime() + now. getTimezoneOffset() * 60000);
      let tosendDate = `${utc.getFullYear()}-${this.get2digitVal(utc.getMonth()+1)}-${this.get2digitVal(utc.getDate())}T${this.get2digitVal(utc.getHours())}:${this.get2digitVal(utc.getMinutes())}:${this.get2digitVal(utc.getSeconds())}.000Z`
      data.createdAt = tosendDate;
      data.updatedAt = tosendDate;
    }
    return this._httpClient.post(`${environment.API_URL}/api/seller/paymentDetails`,data);
  }

  get2digitVal(val:number){
    return (val < 10) ? `0${val}` : val;
  }

  getPaymentProcessor(): Observable<any> {
    return this._httpClient.get(`${environment.API_URL}/api/seller/getPaymentProcessor`);
  }

  stallerToken(data: any): Observable<any> {
    let dt:any= data;
    dt.total = parseFloat(dt.total) / 100;
    return this._httpClient.post(`${environment.API_URL}/api/transactions/transferfund`,dt);
  }

}
